var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon
    ? _c(
        "dl",
        {
          staticClass:
            "icon-details-version-info display-inline-flex flex-items-center",
          staticStyle: {
            "--margin-bottom": "0",
            "--padding-left": "0",
            gap: "var(--spacing-md)",
            "--tag-background": "var(--fa-lt-gravy)",
          },
        },
        [
          _c(
            "dt",
            {
              staticClass: "muted sr-only",
              staticStyle: {
                "--margin-bottom": "0",
                "font-weight": "var(--font-weight-normal)",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.isCustomIcon ? "Uploaded:" : "Released:") +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("dd", { staticStyle: { "--margin-bottom": "0" } }, [
            _c("span", { staticClass: "tag rounded text-select-all" }, [
              _vm._v(_vm._s(_vm.releasedVersion)),
            ]),
          ]),
          _vm._v(" "),
          _vm.releasedVersion !== _vm.updatedVersion
            ? [
                _c(
                  "dt",
                  {
                    staticClass: "muted margin-left-sm sr-only",
                    staticStyle: {
                      "--margin-bottom": "0",
                      "font-weight": "var(--font-weight-normal)",
                    },
                  },
                  [_vm._v("\n      Updated:\n    ")]
                ),
                _vm._v(" "),
                _c("dd", { staticStyle: { "--margin-bottom": "0" } }, [
                  _c("span", { staticClass: "tag rounded text-select-all" }, [
                    _vm._v(_vm._s(_vm.updatedVersion)),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }